/** Shared class helpers for expandable category-tree tables (Souhrn / Katalog / Srovnání cen). */

export function categoryTreeIndentClass(depth: number): string {
  if (depth >= 3) return 'tt-cat-tree__indent--3';
  if (depth >= 2) return 'tt-cat-tree__indent--2';
  if (depth >= 1) return 'tt-cat-tree__indent--1';
  return '';
}

export function categoryTreeCategoryRowClass(): string {
  return 'tt-cat-tree-row tt-cat-tree-row--category';
}

export function categoryTreeTotalRowClass(): string {
  return 'tt-cat-tree-row tt-cat-tree-row--total';
}

export function categoryTreeLeafRowClass(): string {
  return 'tt-cat-tree-row tt-cat-tree-row--leaf';
}

/** Text tone for folder vs leaf in product-category filter trees / dropdowns. */
export const PRODUCT_CATEGORY_FILTER_CATEGORY_LABEL_CLASS = 'tt-cat-tree__label--category';
export const PRODUCT_CATEGORY_FILTER_LEAF_LABEL_CLASS = 'tt-cat-tree__label--leaf';

export function productCategoryFilterNodeLabelClass(hasChildCategories: boolean): string {
  return hasChildCategories
    ? PRODUCT_CATEGORY_FILTER_CATEGORY_LABEL_CLASS
    : PRODUCT_CATEGORY_FILTER_LEAF_LABEL_CLASS;
}

/** Split `pathLabel` from API (`A / B / C` or `A/B/C`). */
export function splitProductCategoryPathLabel(path: string | null | undefined): string[] {
  const raw = String(path ?? '').trim();
  if (!raw || raw === '—') return [];
  return raw
    .split(/\s*\/\s*/)
    .map((s) => s.trim())
    .filter(Boolean);
}

/** Path segments: ancestors = category tone, last = leaf (assigned folder). */
export function productCategoryPathSegmentLabelClass(index: number, totalSegments: number): string {
  if (totalSegments <= 0) return PRODUCT_CATEGORY_FILTER_LEAF_LABEL_CLASS;
  if (totalSegments === 1) return PRODUCT_CATEGORY_FILTER_LEAF_LABEL_CLASS;
  return index < totalSegments - 1
    ? PRODUCT_CATEGORY_FILTER_CATEGORY_LABEL_CLASS
    : PRODUCT_CATEGORY_FILTER_LEAF_LABEL_CLASS;
}
